import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Github } from 'lucide-react';

// Every one of these used to be a <Link to="/#">: twenty labels that all went
// back to the top of the same page. Dead legal links are not cosmetic — a
// payment processor reads a missing privacy policy as a missing business and
// declines the seller application. So each entry now carries where it goes, and
// anything with nowhere real to go was removed rather than faked.
const COLS = [
  { title: 'Product', links: [
    ['What you make', '/#use-cases'],
    ['How it works', '/#how'],
    ['Style templates', '/#styles'],
    ['Pricing', '/pricing'],
  ] },
  { title: 'Use cases', links: [
    ['Product photography', '/#use-cases'],
    ['Model shots', '/#use-cases'],
    ['Professional headshots', '/#use-cases'],
    ['Photo sessions', '/gallery'],
  ] },
  { title: 'Company', links: [
    ['Contact', 'mailto:hello@eagerdragon.com'],
    ['Support', 'mailto:hello@eagerdragon.com'],
    ['Affiliates', '/#pricing'],
  ] },
  { title: 'Legal', links: [
    ['Terms', '/legal/terms'],
    ['Privacy', '/legal/privacy'],
    ['Refunds', '/legal/refunds'],
    ['Licence', '/legal/license'],
    ['Cookies', '/legal/cookies'],
  ] },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
                <circle cx="5" cy="6" r="2.4" fill="#F5A623" />
                <circle cx="5" cy="18" r="2.4" fill="#A78BFA" />
                <circle cx="19" cy="12" r="2.4" fill="#fff" />
                <path d="M7 6.6 17 11.4M7 17.4 17 12.6" stroke="#3A3A42" strokeWidth="1.3" />
              </svg>
              <span className="font-serif-display text-xl text-white">Idolaris</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              Studio product photography without the studio. Shoot your products, put a model in them,
              and get the portrait your profile needs — in minutes, from photos you already have.
            </p>
            <div className="mt-6 flex gap-3">
              {[Twitter, Instagram, Github].map((Icon, i) => (
                <a key={i} href="/#" className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-white/40 hover:text-white">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-white/70">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith('mailto:') ? (
                      <a href={href} className="text-sm text-muted-foreground transition-colors hover:text-white">{label}</a>
                    ) : (
                      <Link to={href} className="text-sm text-muted-foreground transition-colors hover:text-white">{label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-border pt-8 text-xs text-muted-foreground md:flex-row md:items-center">
          <p>© 2026 Eager Dragon Publishing Ltd. All rights reserved.</p>
          <p>Made for creators, marketers &amp; agencies.</p>
        </div>
      </div>
    </footer>
  );
}
